export const initPSWURLS_beta = [
  'https://dontekcontrol.com/ota/Dontek_PSW_V1_17_B01.bin',
  'https://dontekcontrol.com/ota/Dontek_PSW_V1_16_B03.bin',
  'https://dontekcontrol.com/ota/Dontek_PSW_V1_16_B02.bin',
];

export const initPSWURLS = [
  'https://dontekcontrol.com/ota/Dontek_PSW_V1_16_B03.bin',
  'https://dontekcontrol.com/ota/Dontek_PSW_V1_16_B02.bin',
];

export const initACURLS = [
  'https://dontekcontrol.com/ota/EP_v1_02_B01.bin',
  'https://dontekcontrol.com/ota/EP_v1_01_B01.bin',
];

export const initAQUALIGHTURLS_beta = [
  'https://dontekcontrol.com/ota/LightController_V1_03_B04.bin',
  'https://dontekcontrol.com/ota/LightController_v1_03_B03.bin',
  'https://dontekcontrol.com/ota/LightController_v1_01_B03.bin',
];

export const initAQUALIGHTURLS = [
  'https://dontekcontrol.com/ota/LightController_V1_03_B04.bin',
  'https://dontekcontrol.com/ota/LightController_v1_01_B03.bin',
];

// SWC boards. Each board carries its own OTA image, distinct from the PSW and
// AquaLight firmware — cross-flashing a PSW binary onto one of these is exactly
// what these separate lists exist to prevent.
export const initControlBoardUrls = ['https://dontekcontrol.com/ota/ControlBoard.bin'];

export const initPowerBoardUrls = ['https://dontekcontrol.com/ota/PowerBoard.bin'];

export const initIOBoardUrls = ['https://dontekcontrol.com/ota/IOBoard.bin'];

export const initialConnectionState = {
  state: 'Disconnected',
  ready: false,
};

export const initialUpgradeFile = {
  selectedFile: null,
  // Indexed, not hard-coded: the two must never drift apart, or the picker
  // shows blank while Upgrade stays armed with a URL the user can't see.
  // The PSW card renders initPSWURLS_beta instead when BETA_VERSIONS is on, so
  // this default has to appear in that list too — it does, though not first.
  // Keep it in both when re-curating, or pick the default per beta flag.
  selectedFileName: initPSWURLS[0],
};

export const initialUpgradeACFile = {
  selectedFile: null,
  selectedFileName: initACURLS[0],
};

export const initialUpgradeSHFile = {
  selectedFile: null,
  // Empty on purpose: the SmartHeater picker has no list yet, so any concrete
  // default here would be armed but unselectable — the user couldn't see what
  // Upgrade was about to flash, or change it. Upgrade stays disabled until a
  // URL is added. Give SmartHeater its own initSmartHeaterUrls list (as the
  // SWC boards have) once its production image URL is confirmed.
  selectedFileName: '',
};

// Light controllers run their own image. Kept separate from initialUpgradeFile
// so a PSW binary can never be the armed selection on an AquaLight.
export const initialUpgradeLCFile = {
  selectedFile: null,
  selectedFileName: initAQUALIGHTURLS[0],
};

// Indexed off the lists above so the default can never drift out of its own
// picker when the URLs are re-curated.
export const initialUpgradeControlBoardFile = {
  selectedFile: null,
  selectedFileName: initControlBoardUrls[0],
};

export const initialUpgradePowerFile = {
  selectedFile: null,
  selectedFileName: initPowerBoardUrls[0],
};

export const initialUpgradeIOFile = {
  selectedFile: null,
  selectedFileName: initIOBoardUrls[0],
};
